<template>
    <div class="register-selected-institution p-5">
        Ausgewählte Eintrichtung <br>
        <strong>{{ institutionName }}</strong>
    </div>
</template>

<script>

export default {
    name: 'RegisterStep1SelectedInstitution',
    props: {
        institutionName: {
            type: String,
            required: true
        },
    },
}
</script>

<style lang="scss">
.register-selected-institution {
    background-color: $grey;
}
</style>
